/**
 *
 * @author Matthew Rawson @ 01/05/2018 15:54
 * @description
 * @notes
 *
 * Would have used the loading component but it's use of div's doesn't play nicely with this component that is nested
 * in paragraph elements, hence the custom load handling
 *
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {isEqual} from "lodash"

import id from "@irati/utils/id"
import connect from "@irati/store/connect"
import authentication from "@irati/auth"
import TeamActions from "@irati/identity/store/actions/TeamActions"

import {formatScheduleTeamNames} from "../../../helpers/schedule"


class TeamNames extends Component {
  static propTypes = {
    teams: PropTypes.object.isRequired,
    getTenantsTeams: PropTypes.func.isRequired,
    schedule: PropTypes.object
  }
  static defaultProps = {
    schedule: {}
  }


  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.doLoad()
  }

  componentDidUpdate(prevProps) {
    /** If the schedule has changed trigger a team name update */
    if (!isEqual(prevProps.schedule, this.props.schedule)) {
      this.doLoad()
    }
  }

  doLoad = () => {
    this.isLoading(true)
    this.props.getTenantsTeams().then(() => {
      this.isLoading(false)
    })
  }

  isLoading = (loading) => {
    this.setState({loading: loading === true})
  }

  render() {
    const idNamespace = id("TeamNames", this.props)
    const {loading} = this.state
    const {schedule, teams} = this.props

    return (
      <span id={idNamespace}>
        {!loading && formatScheduleTeamNames(schedule, teams)}
      </span>
    )
  }
}

const mapStateToProps = ({teams}) => ({teams})

export const mapDispatchToProps = (dispatch) => ({
  getTenantsTeams: () => dispatch(TeamActions.get(authentication.userTenant()))
})

export default connect(mapStateToProps, mapDispatchToProps)(TeamNames)
